import OptionsHelper from '@/utils/OptionsHelper';
import ListingMapper from '@/components/features/listing-search/mappers/listing';
import { SearchAddressControlValueProps } from '../../../features/sold-data/shared/components/forms/search/enums';

export default class SearchOptionsMapper {
  static mapListingsIntoOptions(listings) {
    const addressOptionsMap = new Map(
      listings.map((listing) => ([listing.address.id, this.#mapListingIntoOption(listing)])),
    );

    return [...addressOptionsMap.values()];
  }

  static #mapListingIntoOption(listing) {
    const fullAddress = ListingMapper.getFullAddress(listing.address);

    return OptionsHelper.createOption(
      fullAddress,
      {
        [SearchAddressControlValueProps.AddressId]: listing.address.id,
        [SearchAddressControlValueProps.Address]: fullAddress,
      },
    );
  }
}
